import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Footer from '../Components/Footer';
import Auth from '../Function/Auth';
import Header from '../Components/Header';
import { toast, ToastContainer } from "react-toastify";

function Support() {
  const authToken = sessionStorage.getItem('authToken');
  const baseurl = process.env.REACT_APP_BASE_API_URL;
  const [analytics, setAnalytics] = useState([]); 
  const [tabelLoading, setTableLoading] = useState(false); 
  const [deposits, setDeposits] = useState([]); 
  const [pagination, setPagination] = useState([]); 
  const [ticketNumber, setTciketNumber] = useState("");
  const [ticketStatus, setStatus] = useState("");
  const [ticketUpdateStatus, setTicketStatus] = useState("");
  const [per_page, setPerPage] = useState("");
  const [viewData, setViewData] = useState("");
  const [answer, setAnswer] = useState("");
  const [isButton, setButton] = useState(true);


  const [error, setError] = useState("");



  useEffect(() => {
    
    fetchTicket(1);
  }, []);


  const fetchTicket = async (page) => {
    console.log('Token ', authToken);

    const searchData = { 
          id: ticketNumber,
          status: ticketStatus
      };

      console.log('Reach Data',searchData);

    try {
      const deposit = await fetch(`${baseurl}/client/support/tickets`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(searchData),
      });

      if (deposit.status === 429) {
        console.error("Rate limit exceeded. Please try again later.");
        return; // Stop further processing
      }

      const depositResult = await deposit.json();
      console.log('Static data', depositResult);

      if (depositResult.status) {
        setAnalytics(depositResult.analytics);
        setDeposits(depositResult.data);
        setPagination(depositResult.pagination);
        setTableLoading(true);
      } else {
        // Handle any error condition
        setTableLoading(true);
        setDeposits("");
      }
    } catch (error) {
      console.error('Fetch error:', error);
    }
  };


  const passData = (depositData) => {
    setAnswer(depositData.answer);
    setViewData(depositData);
    
  };
  


 


  const handlePageChange = async (page) =>{
     
      setTableLoading(false)
      fetchTicket(page);
  }

  const searchData = () =>{
    
    setTableLoading(false)
    fetchTicket(1);
  }


  const updateTicket = async () =>{

    setButton(false);
    const searchData = { 
      ticket_id: viewData.id,
      answer: answer,
      status: ticketUpdateStatus
  };

  console.log('Reach Data',searchData);

try {
  const updateTicket = await fetch(`${baseurl}/client/support/solveTicket`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${authToken}`,
    },
    body: JSON.stringify(searchData),
  });

  if (updateTicket.status === 429) {
    console.error("Rate limit exceeded. Please try again later.");
    return; // Stop further processing
  }

  const result = await updateTicket.json();
  console.log('Update Ticket data', result);

  if (result.status) {
    setButton(true);
    toast.success(result.message)
  } else {
    // Handle any error condition
    toast.error(result.message)
    result(true);
  }
} catch (error) {
  console.error('Fetch error:', error);
}
  }
  return (
    <>
    <Header>
     <Auth/>
        <div className="main-content app-content" >
          <div className="container-fluid">
            {/* Page Header */}
            <div className="d-md-flex d-block align-items-center justify-content-between my-4 page-header-breadcrumb">
              <div>
                <h4 className="mb-0">Support Tickets!</h4>
                
              </div>
            </div>
            {/* End Page Header */}

            {/* row */}
            <div className="row">
              <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                <div className="card overflow-hidden sales-card bg-primary-gradient">
                  <div className="px-3 pt-3  pb-2 pt-0">
                    <div>
                      <h6 className="mb-3 fs-12 text-fixed-white">TOTAL TICKET</h6>
                    </div>
                    <div className="pb-0 mt-0">
                      <div className="d-flex">
                        <div>
                          <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                              {analytics ? analytics.total : '0'}

                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="compositeline" />
                </div>
              </div>

              <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                <div className="card overflow-hidden sales-card bg-warning-gradient">
                  <div className="px-3 pt-3  pb-2 pt-0">
                    <div>
                      <h6 className="mb-3 fs-12 text-fixed-white">OPEN TICKETS</h6>
                    </div>
                    <div className="pb-0 mt-0">
                      <div className="d-flex">
                      <div>
                          <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                            {analytics ? analytics.open : '0'}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="compositeline4" />
                </div>
              </div>
              <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                <div className="card overflow-hidden sales-card bg-danger-gradient">
                  <div className="px-3 pt-3  pb-2 pt-0">
                    <div>
                      <h6 className="mb-3 fs-12 text-fixed-white">IN PROCESS TICKET</h6>
                    </div>
                    <div className="pb-0 mt-0">
                      <div className="d-flex">
                      <div>
                          <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                            {analytics ? analytics.in_process : '0'}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="compositeline2" />
                </div>
              </div>
              <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                <div className="card overflow-hidden sales-card bg-success-gradient">
                  <div className="px-3 pt-3  pb-2 pt-0">
                    <div>
                      <h6 className="mb-3 fs-12 text-fixed-white">SOLVED TICKETS</h6>
                    </div>
                    <div className="pb-0 mt-0">
                      <div className="d-flex">
                      <div>
                          <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                            {analytics ? analytics.solved : '0'}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="compositeline3" />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12 col-lg-12 col-xl-12">
                <div className="card card-table ">
                  <div className="row">


                    <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                        <div className="mt-3 ">
                          <lavel>Ticket Number </lavel>
                          <input type="text" value={ticketNumber} onChange={(e) => setTciketNumber(e.target.value)} className="form-control" placeholder="Enter Clinet Id" />
                        </div>
                    </div>

                    <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                      <div className="mt-3">
                        <label>Status</label>
                        <select className="form-control" value={ticketStatus} onChange={(e) => setStatus(e.target.value)}>
                          <option value="">All</option>
                          <option value="open">Open</option>
                          <option value="in_process">In Process</option>
                          <option value="closed">Solved</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                        <div className="mt-3 text-end">
                          
                          <button onClick={searchData} className="btn btn-primary btn-block mt-3">Search Data</button>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* row closed */}
          
            {/* row opened */}
            <div className="row">
              <div className="col-md-12 col-lg-12 col-xl-12">
                <div className="card card-table">
                  <div className=" card-header p-0 d-flex justify-content-between mt-3">
                    <h3 className="card-title mb-1 text-primary">Ticket History</h3>
                  </div>
                  <div className="table-responsive country-table">
                  {tabelLoading ? (
                    <table className="table table-striped table-bordered mb-0 text-nowrap mt-3" >
                    
                      <thead>
                        <tr>
                          <th className="wd-lg-25p">Ticket Number</th>
                          <th className="wd-lg-25p">User Name</th>
                          <th className="wd-lg-25p">Subject</th>
                          <th className="wd-lg-25p">Description</th>
                          <th className="wd-lg-25p">Date Time</th>
                          <th className="wd-lg-25p">STATUS</th>
                          <th className="wd-lg-25p">ACTION</th>
                        </tr>
                      </thead>
                     
                        <tbody>
                        {deposits.length > 0 ? (
                            deposits.map((depositData, index) => (
                            <tr key={index}>
                                <td>{depositData.id || 'N/A'}</td>
                                <td> {depositData.user_name || 'N/A'} </td>
                                <td> {depositData?.subject ? depositData.subject.slice(0, 15)+'...' : 'N/A'} </td>
                                <td> {depositData?.description ? depositData.description.slice(0, 50)+'...' : 'N/A'} </td>
                                <td> {depositData.date_time || 'N/A'} </td>
                                <td> 
                                {depositData && depositData.status
                                    ? depositData.status === 'closed' ? (
                                        <span className="badge bg-success">closed</span>
                                    ) : (
                                        <span className="badge bg-danger">{depositData.status} </span>
                                    ): 'N/A'}
                                     </td>
                                <td>
                                <a href="#" onClick={() => passData(depositData)} className="btn btn-sm btn-primary" data-bs-toggle="modal"
                                    data-bs-target="#exampleModalXl">
                                    <i className="fa fa-eye"></i>
                                </a>
                                </td>
                            </tr>
                            ))
                        ) : (
                            <tr>
                            <td>No Data Found</td>
                            </tr>
                        )}
                    </tbody>
                    </table>
                      ):(
                        <div className="text-center">
                             <div className="d-flex justify-content-center mb-4">
                                  <div className="spinner-border" role="status">
                                      <span className="visually-hidden">Loading...</span>
                                  </div>
                              </div>
                            </div>
                      )}
                      
                    
                  </div>
                    <div className="gridjs-footer">
                      <div className="gridjs-pagination">
                        <div role="status" aria-live="polite" className="gridjs-summary" title="Page 1 of 1">Showing <b>{pagination.current_page}</b> to <b>{pagination.per_page}</b> of <b>{pagination.total}</b> results</div>
                        <div className="gridjs-pages text-end">
                            {/* Previous Button */}
                            <button  tabIndex="0"  role="button"  title="Previous"  aria-label="Previous"  className={pagination.current_page === 1 ? "disabled" : ""}  onClick={() => handlePageChange(pagination.current_page - 1)}  disabled={pagination.current_page === 1}> Previous</button>

                            {/* First Page */}
                            <button  tabIndex="0"  role="button"  className={` ${pagination.current_page === 1 ? "gridjs-currentPage" : ""}`}  title="Page 1"  aria-label="Page 1"  onClick={() => handlePageChange(1)}> 1</button>

                            {/* Ellipsis if needed */}
                            {pagination.current_page > 3 && <span>...</span>}

                            {/* Middle Pages (2 dynamic pages around current) */}
                            {Array.from({ length: 5 }, (_, i) => { const page = pagination.current_page - 2 + i;
                              if (page > 1 && page < pagination.last_page) {
                                return (
                                  <button key={page} tabIndex="0" role="button" className={` ${pagination.current_page === page ? "gridjs-currentPage" : ""}`} title={`Page ${page}`} 
                                    aria-label={`Page ${page}`} onClick={() => handlePageChange(page)}>
                                    {page}
                                  </button>
                                );
                              }
                              return null;
                            })}

                            {/* Ellipsis if needed */}
                            {pagination.current_page < pagination.last_page - 2 && <span>...</span>}

                            {/* Last Page */}
                            {pagination.last_page > 1 && (
                              <button  tabIndex="0" role="button" className={` ${pagination.current_page === pagination.last_page ? "gridjs-currentPage" : ""}`} title={`Page ${pagination.last_page}`} aria-label={`Page ${pagination.last_page}`} 
                                onClick={() => handlePageChange(pagination.last_page)}>
                                {pagination.last_page}
                              </button>
                            )}

                            {/* Next Button */}
                            <button tabIndex="0" role="button" title="Next" aria-label="Next" className={pagination.current_page === pagination.last_page ? "disabled" : ""} onClick={() => handlePageChange(pagination.current_page + 1)} disabled={pagination.current_page === pagination.last_page}>
                              Next
                            </button>
                          </div>
                      </div>
                    </div>
                </div>
              </div>
            </div>
            {/* /row */}

          </div>
        </div>

        <div className="modal fade" id="exampleModalXl" tabindex="-1" aria-labelledby="exampleModalXlLabel" aria-hidden="true">
            <div className="modal-dialog modal-xl">
                <div className="modal-content">
                    <div className="modal-header">
                        <h6 className="modal-title" id="exampleModalXlLabel">Support Ticket Number : {viewData ? viewData.id : 'N/A'}
                            </h6>
                        <button type="button" className="btn-close" data-bs-dismiss="modal"
                            aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                    <div className="row">

                      <div className="col-xl-12 col-md-12 col-sm-12">
                        <div className="card">
                          <div className="card-header">
                            <h3 className="card-title">Client Name : <b className="text-primary">Shivam</b></h3>
                          </div>
                          <div className="card-body">
                            <form>
                              <div className="form-group mb-3">
                                <div className="row align-items-center">
                                  <label className="col-sm-2">Subject</label>
                                  <div className="col-sm-10">
                                    <h6>{viewData? viewData.subject : 'N/A'}</h6>
                                  </div>
                                </div>
                              </div>
                              <div className="form-group mb-3">
                                <div className="row align-items-center">
                                  <label className="col-sm-2">Query</label>
                                  <div className="col-sm-10">
                                    <span >{viewData? viewData.description : 'N/A'}</span>
                                  </div>
                                </div>
                              </div>
                              <div className="form-group mb-3">
                                <div className="row ">
                                  <label className="col-sm-2">Answer</label>
                                  <div className="col-sm-10">
                                    <textarea  rows={10} className="form-control" value={answer} onChange={(e)=>setAnswer(e.target.value)}/>
                                  </div>
                                </div>
                              </div>

                              <div className="form-group mb-3">
                                <div className="row ">
                                  <label className="col-sm-2">Status</label>
                                  <div className="col-sm-10">
                                    <select className="form-control" onChange={(e)=>setTicketStatus(e.target.value)} >
                                      <option value={viewData? viewData.status : ''} >{viewData? viewData.status : ''}</option>
                                      <option value={'open'}>open</option>
                                      <option value={'in_progress'}>in_progress</option>
                                      <option value={'closed'}>closed</option>

                                    </select>
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                          <div className="card-footer d-sm-flex">
                            
                            <div className="btn-list ms-auto">
                              {isButton ? (
                                <button type="button" onClick={updateTicket} className="btn btn-success btn-space"> Submit</button>
                              ):(
                                <button type="button" className="btn btn-success btn-space"> Processgin...</button>
                              )}
                              
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    </div>
                </div>
            </div>
        </div>

        <ToastContainer/>
        </Header>


      <Footer/>

    </>
  )
}

export default Support